import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=0ee235dc&scoped=true"
var script = {}
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=0ee235dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee235dc",
  null
  
)

export default component.exports